import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import Reveal from "@/components/base/Reveal";
import { features } from "@/mocks/public";

export default function FeaturesSection() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="container-page">
        <SectionHeading
          eyebrow="Fonctionnalités"
          title="Tout ce dont vous avez besoin pour gérer vos locations"
          description="Des modules pensés pour la réalité du terrain : du suivi des loyers jusqu'aux documents, en passant par l'entretien."
        />
        <div className="mt-12 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {features.map((feature, index) => (
            <Reveal key={feature.title} delay={index * 70} className="h-full">
              <div className="card-lift group flex h-full flex-col gap-3 rounded-lg border border-background-200 bg-background-50 p-5 hover:border-primary-300">
                <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-accent-100 text-accent-800 transition-colors duration-300 group-hover:bg-accent-500 group-hover:text-foreground-950">
                  <i className={`${feature.icon} text-xl`} aria-hidden="true" />
                </span>
                <h3 className="text-base font-heading font-semibold text-foreground-950">{feature.title}</h3>
                <p className="text-sm leading-relaxed text-foreground-600">{feature.description}</p>
              </div>
            </Reveal>
          ))}
        </div>
        <div className="mt-10 flex justify-center">
          <Link
            to="/fonctionnalites"
            className="link-arrow inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-foreground-200 bg-background-50 px-5 py-2.5 text-sm font-label font-medium text-foreground-900 hover:bg-background-100 hover:-translate-y-0.5 transition-all cursor-pointer"
          >
            Voir toutes les fonctionnalités
            <i className="ri-arrow-right-line" aria-hidden="true" />
          </Link>
        </div>
      </div>
    </section>
  );
}